'use strict';

const BaseStore = require('fluxible/addons/BaseStore');

class StickyAlertTopStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this._height = 0;
    }

    setHeight(payload) {
        const { height } = payload;
        this._height = height;
        this.emitChange();
    }

    getHeight() {
        return this._height;
    }
}

StickyAlertTopStore.storeName = 'StickyAlertTopStore';

StickyAlertTopStore.handlers = {
    'StickyAlert:top:height': 'setHeight',
};

module.exports = StickyAlertTopStore;



// WEBPACK FOOTER //
// ./assets/js/components/StickyAlert/StickyAlertTop/StickyAlertTop-store.es.js